import Logo from "backpack-ui/dist/components/logo";
import * as cn from "classnames";
import Cookies from "js-cookie";
import * as React from "react";
import Container from "../../../components/container";
import Divider from "../../../components/divider";
import { Button } from "./button";
import { Link } from "./link";
import { Navigation } from "./navigation";
import * as styles from "./styles.css";
var globalHeaderLinks = [
    {
        href: "/",
        items: [
            {
                href: "/best-in-travel",
                text: "Best in travel 2018",
            },
            {
                href: "/video",
                text: "Video",
            },
            {
                href: "/thorntree",
                text: "Thorn Tree Community",
            },
            {
                href: "/news",
                text: "Travel News",
            },
            {
                href: "/kids",
                text: "Lonely Planet Kids",
            },
        ],
        text: "Latest",
    },
    {
        href: "/",
        items: [
            {
                href: "/travel-insurance",
                text: "Travel Insurance",
            },
            {
                href: "/flights",
                text: "Flights",
            },
            {
                href: "/hotels",
                text: "Hotels",
            },
            {
                href: "/tours",
                text: "Tours",
            },
            {
                href: "/car-rentals",
                text: "Car rentals",
            },
        ],
        text: "Travel",
    },
    {
        callout: {
            href: "https://shop.lonelyplanet.com/",
            text: "All merchandise",
        },
        href: "/",
        items: [
            {
                href: "https://shop.lonelyplanet.com/pages/deals",
                text: "Guide books",
            },
            {
                href: "https://shop.lonelyplanet.com/pages/deals",
                text: "Coffee table books",
            },
            {
                href: "https://shop.lonelyplanet.com/pages/deals",
                text: "Lonely Planet Kids",
            },
            {
                href: "https://shop.lonelyplanet.com/pages/deals",
                text: "Magazine",
            },
        ],
        text: "Shop",
    },
];
var profileLinks = [
    {
        href: "/profile/settings",
        text: "Settings",
    },
    {
        href: "/profile/lists",
        text: "Lists",
    },
    {
        href: "/profile/dashboard",
        text: "Community dashboard",
    },
    {
        href: "/profile/messages",
        messages: 2,
        text: "Messages",
    },
];
var hasCart = function () {
    if (!Cookies) {
        return false;
    }
    var hasShopCookie = Cookies.get("shopCartCookie");
    var isOnShop = window.location.origin === "https://shop.lonelyplanet.com";
    return (hasShopCookie || isOnShop);
};
export var GlobalHeader = function (_a) {
    var _b = _a.links, links = _b === void 0 ? globalHeaderLinks : _b, _c = _a.theme, theme = _c === void 0 ? "light" : _c;
    return (React.createElement(React.Fragment, null,
        React.createElement(Link.Skip, null),
        React.createElement(Container, { className: cn(styles.globalHeader, theme === "dark" && styles.globalHeaderDark, theme === "transparent" && styles.globalHeaderTransparent, theme === "legacy" && styles.globalHeaderBlue), element: "header", role: "banner" },
            React.createElement(Button.Search, { className: styles.globalHeaderButtonSearch }),
            React.createElement(Logo, null),
            React.createElement(Navigation.Desktop, { className: styles.globalHeaderNavigationDesktop, links: links, profileLinks: profileLinks, hasCart: hasCart() }),
            React.createElement(Divider, { className: styles.globalHeaderDivider }))));
};



//////////////////
// WEBPACK FOOTER
// ./app/shared/patterns/global/header/index.tsx
// module id = xyyh
// module chunks = 2